import { startRegistration } from '@simplewebauthn/browser';
import { mapWebAuthnError } from '../errors.js';
/** The browser's IANA time zone, or undefined if it can't be read (the server falls back to UTC). */
function browserTimeZone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
    }
    catch {
        return undefined;
    }
}
export function createEnrollmentMethods(request) {
    return {
        list() {
            return request('/users/me/passkeys', { auth: true }).then((res) => res.passkeys);
        },
        async startEnrollment(currentPassword) {
            await request('/users/me/passkeys/enroll/start', {
                method: 'POST',
                auth: true,
                body: { currentPassword },
            });
        },
        async completeEnrollment(enrollmentToken, opts = {}) {
            const optionsJSON = await request('/users/me/passkeys/enroll/options', {
                method: 'POST',
                auth: true,
                body: { enrollmentToken },
            });
            let response;
            try {
                response = await startRegistration({ optionsJSON });
            }
            catch (err) {
                throw mapWebAuthnError(err, 'create');
            }
            const result = await request('/users/me/passkeys/enroll/verify', {
                method: 'POST',
                auth: true,
                body: { enrollmentToken, response, name: opts.name, timeZone: browserTimeZone() },
            });
            return result.passkey;
        },
        rename(id, name) {
            return request(`/users/me/passkeys/${id}`, {
                method: 'PATCH',
                auth: true,
                body: { name },
            }).then((res) => res.passkey);
        },
        async remove(id, currentPassword) {
            await request(`/users/me/passkeys/${id}`, {
                method: 'DELETE',
                auth: true,
                body: { currentPassword },
            });
        },
    };
}
